<template>
    <md-card class="word-packs">
        <md-card-header>
            <div class="md-title">Word Packs</div>
        </md-card-header>
        <md-card-content v-for="pack in packs" :key="pack.key">
            <md-button v-if="selectedPacks.contains(pack.key)" :md-ripple="true" class="md-raised">pack.key</md-button>
            <md-button v-else :md-ripple="true">pack.key</md-button>
        </md-card-content>
    </md-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WordPacks',
  props: {
  },
   data: () => ({
  }),
  computed: {
    ...mapGetters({
      packs: 'packs',
      selectedPacks: 'selectedPacks'
    })
  },
  methods: {
    NewGame() {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.word-packs {
    width:15rem;
}
</style>